// custom enums
import { agencyType } from 'src/app/core/enums/user/agency-type';


export const ListOfAgencyType = [
    { name: 'شركة', value: agencyType.company },
    { name: 'مكتب عقاري', value: agencyType.office },
    { name: 'وسيط عقاري', value: agencyType.freeWork }
];